import Link from 'next/link';

import { Button, useSlotRecipe } from '@chakra-ui/react';

import { PageButtonProps } from './page-button.props';

export const PageButton = ({
    page,
    isCurrent,
    ariaLabel,
    pageUrl,
    onPageChange,
}: PageButtonProps) => {
    const recipe = useSlotRecipe({ key: 'pagination' });
    const styles = recipe({});

    const commonProps = {
        'aria-label': ariaLabel,
        size: 'sm' as const,
        css: styles.button,
        _hover: { bg: 'secondary.600' },
        'data-testid': 'pagination-page-btn',
    };

    if (isCurrent) {
        return (
            <Button {...commonProps} aria-current={'page'} data-active>
                {page}
            </Button>
        );
    }

    return (
        <Button {...commonProps} asChild>
            <Link href={pageUrl} prefetch={false} onClick={onPageChange}>
                {page}
            </Link>
        </Button>
    );
};
